import { connect } from 'react-redux';
import DeleteHazardControlDialog from '../../components/EditHazardPanel/DeletHazardControlDialog';

import {
  openDeleteHazardControlDialogDispatch,
  handleDeleteHazardControlClickDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    toDeleteControl: state.hazard.deleteControl.item,
    open: state.hazard.deleteControl.showDeleteHazardControlDialog,
    isSaving: state.hazard.deleteControl.isSaving,
    errorMessage: state.hazard.deleteControl.errorMessage
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    showDialog: (open, controlId) => {
      dispatch(openDeleteHazardControlDialogDispatch(open, controlId));
    },
    onConfirmHazardControlDelete: (payload) => {
      dispatch(handleDeleteHazardControlClickDispatch(payload));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteHazardControlDialog);
